<template>
  <v2-row noSpace>
    <v2-col col12 noSpaceX noSpace>
      <v2-textfield
        :label="$t('quickLaunch.labels.calendlyUrl')"
        v-model="calendlyUrl"
        name="calendlyUrl"
        v-validate="{
          required: true,
          regex: /https?:\/\/calendly\.com(\/([\w-]{1,90})){1,3}$/,
        }"
        @input="setChangedComp()"
        :error="errors.first('calendlyUrl')"
        :data-vv-as="$t('quickLaunch.labels.calendlyUrl')"
      ></v2-textfield>
    </v2-col>
    <v2-col col12 class="items-end" noSpaceX noSpace>
      <v2-button outline primary @click.native="saveComponent(false)">{{ $t("quickLaunch.actions.save") }}</v2-button>
    </v2-col>
  </v2-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuickLaunchCalendly",
  props: {
    component: Object,
  },
  data() {
    return {
      calendlyUrl: "",
      hasChanged: false,
    };
  },
  created() {
    this.calendlyUrl = this.component.value.calendlyUrl;
    this.$eventbus.$on("saveComponents", () => {
      this.saveComponent(true);
    });
  },
  methods: {
    ...mapActions(["updateComponent"]),
    setChangedComp() {
      this.hasChanged = true;
      this.$eventbus.$emit("setUnsavedComponents", this.component.uid);
    },
    saveComponent(isEvent = false) {
      if (this.hasChanged) {
        const vm = this;
        vm.$validator.validateAll().then((result) => {
          if (result) {
            const data = {
              customLoading: true,
              params: {
                project: vm.currentProject.uid,
                component: vm.component.uid,
              },
              data: {
                value: { calendlyUrl: vm.calendlyUrl },
                type: "calendly",
              },
            };
            vm.updateComponent(data)
              .then(() => {
                vm.$eventbus.$emit("componentSavedSuccess", this.component.uid, isEvent);
                vm.hasChanged = false;
                if (!isEvent) {
                  vm.$snotify.success(vm.$t("quickLaunch.toasts.saveComponent.success"), vm.$t("toasts.success"), {
                    icon: vm.$successIcon,
                  });
                }
              })
              .catch(() => {
                vm.$eventbus.$emit("componentSavedError", this.component.uid);
                if (!isEvent) {
                  vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.error"), vm.$t("toasts.error"), {
                    timeout: 0,
                    icon: vm.$errorIcon,
                  });
                }
              });
          } else {
            vm.$eventbus.$emit("componentSavedError", this.component.uid);
            if (!isEvent) {
              vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            }
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      currentProject: "projects_get_current_project",
    }),
  },
};
</script>
